<template>
  <div v-if="this.cellValue === true">
    <vs-chip class="h-5 my-3" color="success">
      <vs-avatar icon-pack="feather" icon="icon-check-circle" />
      <span>Enabled</span> 
    </vs-chip>
  </div>
  <div v-else>
    <vs-chip  class="h-5 my-3" color="danger">
      <vs-avatar icon-pack="feather" icon="icon-slash" />
      <span>Disabled</span>
    </vs-chip>
  </div>
</template>

<script>
  export default {
      name: 'CellRendererBadge',
      methods: { 
        getValueToDisplay(params) {
          return params.valueFormatted ? params.valueFormatted : params.value;
        }
      },
      data: () => {
        return {
          cellValue: null,
        }
      },
      beforeMount() {
        this.cellValue = this.getValueToDisplay(this.params);
      },
  }
</script>